import { Box, CircularProgress, IconButton, Tooltip } from '@mui/material';
import React, { useState } from 'react';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { CSVDownload } from 'react-csv';
import './downloadCSV.scss'
import instance from '../../utils/axiosInstance';
import { apiBasePathUserDetail } from '../../constants/env-url';
import { DownloadUserData } from '../../constants/api-urlConstants';
import { MessageText } from '../../constants/messageText';
import { SnackBarMessage } from '../snackBar/snackBar';
import { TimerValusSet } from '../../context/TimerContext';

export const DownloadUserCSV: React.FC<any> = (props: any) => {
  const { setUserHeartBeat, timeExit } = React.useContext(TimerValusSet);
  const [downlodData, setDownloadData] = React.useState<any>(null);
  const [statusIsLoading, setStatusIsLoading] = useState(false);
  const [msgConfig, setMsgConfig] = React.useState({
    type: '',
    message: '',
    snackFlag: false
  })

  const downloadCSVFile = () => {
    setStatusIsLoading(true);
    const payload = {
      name: encodeURIComponent(props.searchParamValue)
    }
    const BASE_PATH_URL = `${apiBasePathUserDetail}${DownloadUserData}`;
    instance
      .post(BASE_PATH_URL, payload)
      .then((response) => {
        setUserHeartBeat(timeExit());
        setStatusIsLoading(false);
        if (response.data.length > 0) {
          setDownloadData(response.data)
          setMsgConfig({
            type: 'success',
            message: MessageText.DOWNLOAD_COMPLETED,
            snackFlag: true
          })
        }
        else {
          setMsgConfig({
            type: 'error',
            message: MessageText.DOWNLOAD_FAILED,
            snackFlag: true
          })
        }
      })
      .catch((error) => {
        setStatusIsLoading(false);
        setMsgConfig({
          type: 'error',
          message: MessageText.WENT_WRONG,
          snackFlag: true
        })
      })
  }
  return (
    <>
      <div className='downloadFile'>
        {statusIsLoading && <IconButton disableRipple disableFocusRipple aria-lable="circular" className='downloadButton' > <CircularProgress size={20} /> </IconButton>}
        {!statusIsLoading &&
          <Box>
            <Tooltip title='Download Create Account Template'>
              <IconButton sx={{ border: '1px solid', borderRadius: '4px' }} color="primary" aria-label="add to shopping cart" onClick={downloadCSVFile}>
                <CloudDownloadIcon />
              </IconButton>
            </Tooltip>
            {downlodData != null ? <CSVDownload data={downlodData} filename={"users.csv"} target="_blank" /> : null}
          </Box>}
      </div>
      {msgConfig.snackFlag && <Box sx={{ position: 'absolute' }}>
        <SnackBarMessage snacBarValue={msgConfig}
        />
      </Box>
      }
    </>
  )
}